import { Gift, ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { waLink, astrologerWaMessage } from "@/lib/whatsapp";

const AnnouncementBar = () => {
  const site = useSite();
  return (
    <a
      href={waLink(site.whatsapp_number, astrologerWaMessage)}
      target="_blank"
      rel="nofollow noopener noreferrer"
      data-testid="announcement-bar"
      className="group block bg-secondary text-white text-center text-xs sm:text-sm py-2 px-4 hover:bg-[#52131A] transition-colors"
    >
      <span className="inline-flex items-center gap-2 flex-wrap justify-center">
        <Gift className="h-4 w-4 text-gold shrink-0" />
        <span>
          <span className="font-semibold text-gold">Free astrologer consultation</span>
          <span className="text-white/85"> + complete Gokarna yatra assistance with every pooja booking</span>
        </span>
        <span className="inline-flex items-center gap-1 font-semibold text-gold underline-offset-2 group-hover:underline">
          Chat now <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 transition-transform" />
        </span>
      </span>
    </a>
  );
};

export default AnnouncementBar;
